import {Injectable} from "@angular/core";
import DatoCmsPlugin from "datocms-plugins-sdk";
import {defer, Observable} from "rxjs";
import {map, shareReplay} from "rxjs/operators";

@Injectable()
export class DatoCmsService {

  constructor() {
  }

  /**
   * Return an Observable that will init a DatoCMS plugin
   * on first subscription, emitting the initialized plugin.
   * On next subscriptions, the same initialized plugin will be emitted again.
   */
  getPluginInitializer(): Observable<any> {
    return defer(DatoCmsPlugin.init)
      .pipe(
        map(plugin => {
          plugin.startAutoResizer();
          return plugin;
        }),
        shareReplay(1)
      );
  }
}
